




































































































import Vue from "vue";
import UsersColors from "@/constants/usersColors";
import SingleBlock from "@/components/travel_planning/SingleBlock.vue";
import LabelHorizontal from "@/components/travel_planning/LabelHorizontal.vue";
import LabelVertical from "@/components/travel_planning/LabelVertical.vue";
import TravelModesColors from "@/constants/travelModesColors";
// import DigitalTransform from "vue-digital-transform";
// import ApiService from "@/services/ApiService";
export default Vue.extend({
  components: {
    // DigitalTransform,
    SingleBlock,
    LabelHorizontal,
    LabelVertical,
  },
  props: ["stats"],
  data() {
    return {
      number: null,
      interval: 1200,
      dislocation: true,
      chartData: {
        columns: ["date", "cost", "profit"],
        rows: [
          { date: "01/01", cost: 123, profit: 3 },
          { date: "01/02", cost: 1223, profit: 6 },
          { date: "01/03", cost: 2123, profit: 900 },
          { date: "01/04", cost: 4123, profit: 12 },
          { date: "01/05", cost: 3123, profit: 15 },
          { date: "01/06", cost: 7123, profit: 2022 },
        ],
      },
      userTypesColors: { ...UsersColors },
      colors: { ...TravelModesColors },
      chartSettings: {
        stack: {
          xxx: ["cost", "profit"],
        },
      },
      stackedChartSettings: {
        stack: {
          xxx: ["parents", "staff"],
        },
        colors: ["red"],
      },
      stackedChart: {
        columns: ["distance_group", "parents", "staff"],
        rows: [
          {
            date: "Year 1",
            parents: 5,
            staff: 32,
            train: 12,
            walk: 7,
            bike: 44,
          },
          {
            date: "Year 2",
            parents: 14,
            staff: 35,
            train: 12,
            walk: 29,
            bike: 10,
          },
        ],
      },
    };
  },
  computed: {
    journeysDistributionByDistance: function () {
      if (this.stats) {
        return {
          columns: ["distance_group", "parents", "staff"],
          rows: this.stats.journeysDistributionByDistance,
        };
      } else {
        return null;
      }
    },
  },
  mounted() {
    setTimeout(() => (this.number = 545), 2200);
  },
});
